import React from "react";
import {BasePage} from "app/types/PageTypes";
import {Redirect, Switch} from "react-router-dom";

const SalePage = (props: BasePage) => {
  return (
      <Switch>
        {props.children}
        <Redirect to="/sale"/>
      </Switch>
  );
};

export default SalePage;
